module.exports = __webpack_public_path__ + "static/media/img_15.1deb9a81.png";